export default [
    'Economy',
    'Pre Economy',
    'Business',
    'First',
    'Private Jet',
]